import { api } from '@/config/index.js'
import httpApi from '@/utils/http-api.js'

export default {
  refreshToken: () => {
    return httpApi.postRefreshTokenDataViaApi({
      url: api.auth.refreshToken,
      body: {}
    })
  }
}
